import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { SettingsAsObject, SettingsParamValue } from '@core/models/settings.model';
import { RouteEntity } from '@core/router/router.entity';
import { AppState } from '@core/state/app.state';
import { UserState } from '@core/state/user.state';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';


/**
 * Access service to application modules based on authorization
 */
@Injectable({
    providedIn: 'root',
})
export class AuthGuard {
    readonly #appState: AppState = inject(AppState);
    readonly #userState: UserState = inject(UserState);
    readonly #router: Router = inject(Router);

    public canActivateChild(): Observable<boolean> {
        return this.#userState.isAuthorized$.pipe(
            map((authed: boolean) => {
                if (!authed) {
                    this.#router.navigate([RouteEntity.Root, RouteEntity.Login]);

                    return false;
                }

                return true;
            }),
            take(1),
        );
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return combineLatest([
            this.#userState.isAuthorized$,
            this.#appState.settings$,
        ]).pipe(
            filter(([isAuth, settings]: [boolean, SettingsAsObject]) => isAuth !== null && settings !== null),
            map(([isAuth, settings]: [boolean, SettingsAsObject]) => {
                if (!isAuth) {
                    this.#router.navigate([RouteEntity.Root, RouteEntity.Login]);

                    return false;
                }

                if (state.url.includes(RouteEntity.Root + RouteEntity.Basket) && settings.CLIENT_TICKET_REG !== SettingsParamValue.Y) {
                    this.#router.navigate([RouteEntity.Root, RouteEntity.Tickets]);

                    return false;
                }

                if (state.url.includes(RouteEntity.Root + RouteEntity.Topup) && settings.CLIENT_WALLET_REG !== SettingsParamValue.Y) {
                    this.#router.navigate([RouteEntity.Root, RouteEntity.Tickets]);

                    return false;
                }

                return true;
            }),
            take(1),
        );
    }
}
